import { Component } from 'react';
import classnames from 'classnames';
import styles from './PageHeader.scss';

/**
 * @deprecated In Favor Of ComposablePageHeader
 * @see ComposablePageHeader
 */
export default class PageHeader extends Component {
    render(){
        const {
            headerText,
            subText,
            children
        } = this.props;

        return (
            <section className={styles.PageHeader} data-cy="PageHeader">
                <div className={styles.PageHeader__content} data-cy="PageHeader-text">
                    {headerText && <HeaderTextComponent className={styles.PageHeader__title} text={headerText} />}
                    {subText && <SubTextComponent className={styles.PageHeader__text} text={subText} />}
                </div>
                <div className={styles.PageHeader__actions} data-cy="PageHeader-children">
                    {children}
                </div>
            </section>
        );
    }
}

const HeaderTextComponent = ({text , className}) => <h1 className={className} data-cy="PageHeader-text">{text}</h1>;

const SubTextComponent = ({text, className}) => <p className={className} data-cy="PageHeader-SubText">{text}</p>;


export const MainContent = ({children}) => <div className={styles.PageHeader__content} data-cy="PageHeader-MainContent">{children}</div>;

export const SideContent = ({children}) => <div className={styles.PageHeader__actions} data-cy="PageHeader-SideContent">{children}</div>;

export const ComposablePageHeader = ({children, className}) => 
    <section className={classnames(styles.PageHeader, className)} data-cy="PageHeader-ComposablePageHeader">
        {children}
    </section>;
